import {
  CircleProgressComponent,
  NgCircleProgressModule,
} from 'ng-circle-progress';
import {
  NgbModule,
  NgbProgressbar,
  NgbAlert,
} from '@ng-bootstrap/ng-bootstrap';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { CarouselComponent, CarouselModule } from 'ngx-owl-carousel-o';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { OnboardingStepperComponent } from './components/onboarding-stepper/onboarding-stepper.component';
import { VideoComponent } from '../questionary/components/video/video.component';
import { CustomDatePipe, CustomDatePipeShort } from './pipes/formatDate.pipe';
import { PercentByPipe } from './pipes/percent-by.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { CardComponent } from './components/card/card.component';
import { BarChartComponent } from './components/charts/bar-chart/bar-chart/bar-chart.component';
import { DoughnutChartComponent } from './components/charts/doughnut-chart/doughnut-chart.component';
import { PolarChartComponent } from './components/charts/polar-chart/polar-chart/polar-chart.component';
import { RadarChartComponent } from './components/charts/radar-chart/radar-chart/radar-chart.component';
import { LineChartComponent } from './components/charts/line-chart/line-chart.component';
import { LoadingComponent } from './components/loading/loading.component';
import {
  ModalComponent,
  ModalContent,
} from './components/modal/modal.component';
import { PanelComponent } from './components/panel/panel.component';
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';
import { RadioComponent } from './components/radio/radio.component';
import { EmptyPageComponent } from './layouts/empty-page/empty-page.component';
import { LoaderComponent } from './components/loader/loader.component';
import { MembershipCardComponent } from '../user/components/membership-card/membership-card.component';
import { GraphComponent } from './components/charts/graph/graph.component';
import { TermsPageComponent } from './pages/terms-page/terms-page.component';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';
import { GpdrComponent } from './components/gpdr/gpdr.component';
import { ShowRoomComponent } from './components/show-room/show-room.component';
import { ShowCodeComponent } from './components/show-code/show-code.component';
import { FilterStudentsPipe } from './pipes/filter-students.pipe';
import { EditUserComponent } from './components/edit-user/edit-user.component';
import { ArrowIconComponent } from './components/icons/arrow-icon/arrow-icon.component';
import { DetailStadisticsComponent } from './components/detail-stadistics/detail-stadistics.component';
import { HeaderComponent } from './components/header/header.component';
import { ProgressResumeComponent } from './components/progress-resume/progress-resume.component';
import { CreationalPagesLayoutComponent } from './layouts/modern-pages-layout/creational-pages-layout.component';
import { CreationalPagesFooterComponent } from './components/creational-pages-footer/creational-pages-footer.component';
import { ModernDrawerComponent } from './components/modern-drawer/modern-drawer.component';
import { SearchListBarComponent } from './components/search-list-bar/search-list-bar.component';
import { SelectorComponent } from './components/selector/selector.component';
import { ListElementComponent } from './components/list-element/list-element.component';
import { TrimStringPipe } from './pipes/trim-string.pipe';
import { NewClassPageComponent } from './components/new-class-page/new-class-page.component';
import { SvgIconComponent } from '../user/components/svg-icon/svg-icon.component';
import { ImageComponent } from './components/image/image.component';
import { CustomPercentagePipe } from './pipes/custom-percentage.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { WellnessNotificationsComponent } from './components/wellness-notifications/wellness-notifications.component';
import { WellnessPopupComponent } from './components/wellness-popup/wellness-popup.component';
import {FooterComponent} from "./components/footer/footer.component";
import {ChatbotComponent} from "./components/chatbot/chatbot.component";
import {SkeletonComponent} from "./components/skeleton/skeleton.component";
import { ListSkeletonComponent } from './components/list-skeleton/list-skeleton.component';
import { AiSummaryPanelComponent } from './components/ai-summary-panel/ai-summary-panel.component';
import { AppInitLoaderComponent } from './components/app-init-loader/app-init-loader.component';
import { ClassRangeFiltersComponent } from './components/class-range-filters/class-range-filters.component';

@NgModule({
  declarations: [
    HeaderComponent,
    ModalComponent,
    ModalContent,
    OnboardingStepperComponent,
    LoadingComponent,
    CardComponent,
    VideoComponent,
    PanelComponent,
    DashboardLayoutComponent,
    RadioComponent,
    MembershipCardComponent,
    EmptyPageComponent,
    LoaderComponent,
    TermsPageComponent,
    ToggleSwitchComponent,

    // Chart Components
    RadarChartComponent,
    BarChartComponent,
    DoughnutChartComponent,
    PolarChartComponent,
    GraphComponent,
    LineChartComponent,

    // pipes
    PercentByPipe,
    CustomDatePipe,
    CustomDatePipeShort,
    GpdrComponent,

    //Components
    ShowRoomComponent,
    ShowCodeComponent,
    FilterStudentsPipe,
    EditUserComponent,
    ArrowIconComponent,
    DetailStadisticsComponent,
    ProgressResumeComponent,
    CreationalPagesLayoutComponent,
    CreationalPagesFooterComponent,
    ModernDrawerComponent,
    SearchListBarComponent,
    SelectorComponent,
    ListElementComponent,
    TrimStringPipe,
    NewClassPageComponent,
    SvgIconComponent,
    ImageComponent,
    CustomPercentagePipe,
    WellnessNotificationsComponent,
    WellnessPopupComponent,
    AiSummaryPanelComponent,
    AppInitLoaderComponent,
    ClassRangeFiltersComponent,
  ],
  exports: [
    ProgressResumeComponent,
    HeaderComponent,
    DetailStadisticsComponent,
    ArrowIconComponent,
    ModalComponent,
    ModalContent,
    OnboardingStepperComponent,
    LoadingComponent,
    CardComponent,
    VideoComponent,
    PanelComponent,
    CarouselComponent,
    DashboardLayoutComponent,
    CarouselModule,
    RadioComponent,
    MembershipCardComponent,
    EmptyPageComponent,
    LoaderComponent,
    ToggleSwitchComponent,
    GpdrComponent,
    ShowRoomComponent,
    ShowCodeComponent,
    EditUserComponent,
    SvgIconComponent,

    // Chart
    CircleProgressComponent,
    DoughnutChartComponent,
    PolarChartComponent,
    RadarChartComponent,
    BarChartComponent,
    GraphComponent,
    LineChartComponent,

    // Bootstrap
    NgbProgressbar,
    NgbAlert,

    // pipes
    SafeHtmlPipe,
    PercentByPipe,
    CustomDatePipe,
    CustomDatePipeShort,
    FilterStudentsPipe,

    FormsModule,
    ReactiveFormsModule,
    SearchListBarComponent,
    SelectorComponent,
    ListElementComponent,
    WellnessNotificationsComponent,
    WellnessPopupComponent,
    ListSkeletonComponent,
    AiSummaryPanelComponent,
    AppInitLoaderComponent,
    ClassRangeFiltersComponent,
  ],
  imports: [
    // Chart
    NgCircleProgressModule.forRoot({}),
    CommonModule,
    CarouselModule,
    RouterModule,
    NgbModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgOptimizedImage,
    SafeHtmlPipe,
    FooterComponent,
    ChatbotComponent,
    SkeletonComponent,
    ListSkeletonComponent
  ],
})
export class SharedModule { }
